import gql from 'graphql-tag';

export default gql`
  mutation ($input: uploadPremiumHEMWebTourImageInput!) {
    uploadPremiumHEMWebTourImage(input: $input) {
      scanAndUploadSuccess
      imgPath
      url
    }
  }
`;
